import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useSnackbar } from '../../../global/context/SnackbarContext'
import { PercentIcon } from '../../../icons/PercentIcon'
import { TextSmall } from '../../../ui/Typography/Typography'
import { Modal } from '../../../ui/v2/Modal'

interface RecalculateModalProps {
  currentPercentage: number
  onCancel: () => void
  onConfirm: (percentage: number) => void
}

export const RecalculateModal: React.FC<RecalculateModalProps> = ({
  currentPercentage,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation()
  const [newPercentage, setNewPercentage] = useState<number>()
  const [error, setError] = useState<boolean>(false)
  const { addSnackbar } = useSnackbar()
  const handleConfirm = () => {
    if (!newPercentage || isNaN(newPercentage) || newPercentage < 0.1 || newPercentage > 100) {
      setError(true)
      addSnackbar.error({
        message: t(
          'IB.RebatesPage.ApprovalsPage.Please enter a valid percentage between 0 and 100'
        ),
      })
      return
    }

    onConfirm(newPercentage)
  }

  const handleChange = (val: number) => {
    setNewPercentage(val)
    setError(false)
  }

  return (
    <Modal.FromToRange
      title={t('IB.RebatesPage.ApprovalsPage.Recalculate rebate')}
      icon={PercentIcon}
      inputType='number'
      fromValue={currentPercentage}
      toValue={newPercentage}
      errors={{ to: error }}
      onClose={onCancel}
      onConfirm={handleConfirm}
      onToChange={handleChange}
    >
      <TextSmall>
        {t('IB.RebatesPage.ApprovalsPage.New changes will be applied to current')}
      </TextSmall>
    </Modal.FromToRange>
  )
}
